<template lang="html">

</template>

<script>
import inputTags from "./inputTags.vue";
import dropdownSelect from "./dropdownSelect.vue";
import getUrlParameter from "../helpers/queryString.js";
import Bus from "./Bus.js";
import axios from "axios";
import { REST } from "./Rest.js";

export default {
  name: "search-bar",

  props: {
    "total-posts": {
      default: 0
    },

    category: {
      type: String,
      required: true
    },

    tag: {
      type: String,
      required: true
    },

    autoSearch: {
      type: Boolean,
      default: true
    }
  },

  components: {
    inputTags,
    dropdownSelect
  },

  data: function() {
    return {
      search: {
        s: ""
      },
      categoryTerms: [],
      tagTerms: []
    };
  },

  mounted: function() {
    let vm = this;
    this.getAllTerms();

    Bus.$on("option-select", function(option, category) {
      if (!vm.search[category]) {
        vm.search[category] = [];
      }
      vm.search[category].push(option);

      if (vm.autoSearch) {
        vm.submitSearch();
      }
    });

    Bus.$on("option-deselect", function(option, category) {
      if (category == "s") {
        vm.search.s = "";
      } else {
        let toSearch = vm.search[category];

        for (let i = 0, length = toSearch.length; i < length; i++) {
          if (
            typeof toSearch[i] == "object" &&
            toSearch[i].slug === option.slug
          ) {
            toSearch.splice(i, 1);
            break;
          }
        }
      }

      if (vm.autoSearch) {
        vm.submitSearch();
      }
    });
  },

  methods: {
    redirectSearch: function(loc = "/find-an-inn") {
      let queryBase = siteGlobals.baseUrl + loc + "?";
      let query = [];

      for (let key in this.search) {
        if (this.search[key] !== null && this.search[key] !== "") {
          if (key === "s") {
            query.push("search=" + this.search[key]);
          } else if (typeof this.search[key] == "object") {
            let slugs = this.search[key].map(obj => {
              return obj.slug;
            });
            query.push(key + "=" + slugs.join(","));
          }
        }
      }
      window.location = queryBase + query.join("&");
    },

    submitSearch: function() {
      Bus.$emit("option-sync", this._data.search);
      Bus.$emit("search-submit", this.search);
    },

    reset: function() {
      this.search = {
        s: ""
      };
    },

    /*
      Look for query params in window to use in initial post fetching
    */
    checkInitialQueryParams: function() {
      let possibleParams = ["regions", "amenities", "page", "search"];
      let foundParams = {};

      for (var i = 0; i < possibleParams.length; i++) {
        let p = getUrlParameter(possibleParams[i]);

        if (p != null && p != "" && typeof p == "string") {
          //translate 'search' to 's' because 's' is used by wordpress
          if (possibleParams[i] === "search") {
            this.search.s = p;
            foundParams["s"] = p;
          } else {
            // Bus.$emit("option-select", p, possibleParams[i]);
            if (
              possibleParams[i] == this.tag ||
              possibleParams[i] == this.category
            ) {
              let paramsList =
                possibleParams[i] == this.tag
                  ? this.tagTerms
                  : this.categoryTerms;

              let queryList = p.split(",");
              let found = paramsList.filter(obj => {
                return queryList.indexOf(obj.slug) > -1;
              });

              if (!this.search[possibleParams[i]]) {
                this.search[possibleParams[i]] = found;
              } else {
                this.search[possibleParams[i]].push(p);
              }
            }
            foundParams[possibleParams[i]] = p;
          }
        }
      }
      if (this.autoSearch) {
        this.submitSearch();
      }

      // return foundParams;
    },

    getAllTerms: function() {
      let vm = this;
      let tags = vm.getTagTerms();
      let cats = vm.getCategoryTerms();

      Promise.all([tags, cats]).then(
        axios.spread(function(tags, cats) {
          vm.tagTerms = tags.data;
          vm.categoryTerms = cats.data;
          vm.checkInitialQueryParams();
        })
      );
    },

    getTagTerms: function() {
      let vm = this;
      return REST.get("/terms/" + vm.tag);
    },

    getCategoryTerms: function() {
      let vm = this;

      return REST.get("/terms/" + vm.category, {
        params: {
          hierarchical: true
        }
      });
    }
  }
};
</script>

<style lang="css">
</style>
